export default "__VITE_ASSET__CO3VobAL__"